<template>
    <span class="bx_input bx_textarea" :class="wrapperClass">
        <component :is="labelTag" v-if="placeholder" v-show="isShowPlaceholder" :class="labelClass" @click="onClickPlaceholder()">{{placeholder}}</component>
        <textarea ref="input" :id="id" v-on="listeners" :value="innerValue" :maxlength="maxlength" v-bind="$attrs"
                  @keydown.enter="onKeydownEnter" @paste="onPaste"></textarea>
        <span class="bx_count" v-if="showCount">
            <!-- [D] 0인 경우 : num 에 zero 클래스 추가 -->
            <span class="num" :class="{zero: isAddZeroClass}">{{valueLength}}</span>/{{maxlength}}
        </span>
    </span>
</template>

<script>
import inputs from '@/iamteacherpc/mixins/inputs.js';

export default {
    name: "TextArea",
    inheritAttrs: false,

    props: {
        id: {
            type: String,
        },
        placeholder: {
            type: String,
        },
            value: {
                type: String
            },
            showCount: {
                type: Boolean,
                default: false
            },
            maxlength: {
                type: Number
            },
            wrapperClass: {
                type: String,
                default: ''
            },
            labelClass: {
                type: String,
                default: 'textarea_info'
            },
            labelTag: {
                type: String,
                default: 'span'
            },
            resize: {
                type: Boolean,
                default: false
            },
            maxHeight: {
                type: Number,
                default: Number.MAX_SAFE_INTEGER
            },
            oneLine: {
                type: Boolean,
                default: false
            }
        },

        mixins: [inputs],

        data() {
            return {}
        },

        watch: {
            innerValue() {
                if (this.resize) {
                    this.$nextTick(this.doResize);
                }
            }
        },

        methods: {
            onClickPlaceholder() {
                this.$refs.input.focus();
            },

            doResize() {
                this.$refs.input.style.height = 'auto';
                this.$refs.input.style.overflow = 'hidden';

                let height = this.$refs.input.scrollHeight;

                if (height > this.maxHeight) {
                    height = this.maxHeight;
                    this.$refs.input.style.overflow = 'auto';
                }

                this.$refs.input.style.height = height + 'px';
            },

            onPaste(event) {
                if (!this.oneLine) {
                    return;
                }

                event.preventDefault();

                const clipboardData = event.clipboardData || window.clipboardData;
                const text = clipboardData.getData('text');

                if (typeof text !== 'string') {
                    return;
                }

                const newText = this.getNextValue(text.replace(/[\n\r]/g, ''), true);

                const startPos = event.target.selectionStart;
                const endPos = event.target.selectionEnd;

                const oldText = event.target.value;
                const prefix = oldText.substr(0, startPos);
                const suffix = oldText.substr(endPos);
                const pos = prefix.length + newText.length;

                const newValue = (prefix + newText + suffix).substr(0, this.maxlength || Number.MAX_SAFE_INTEGER);
                this.innerValue = newValue;
                this.$emit('input', newValue);

                // IE는 값을 세팅하고 바로 실행하면 커서 이동이 안 됨
                // $nextTick()으로도 해결이 안 되었음
                setTimeout(function () {
                    event.target.setSelectionRange(pos, pos);
                    event.target.blur();
                    event.target.focus();
                }, 0);
            },

            onKeydownEnter(event) {
                if (this.oneLine) {
                    event.preventDefault();
                }
            }
        },

        created() {
            if (this.resize && this.value) {
                this.$nextTick(this.doResize);
            }
        }
    }
</script>

<style scoped>

</style>
